import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Rajesh Kumar",
    qualification: "MBBS, MS - ENT, MCh - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "18 Years Experience",
    location: "2nd Floor, Elite Tower, Jubilee Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Rhinoplasty Specialist"
  },
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MS - ENT, Fellowship - Facial Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Cosmetic Rhinoplasty Expert"
  },
  {
    name: "Dr. Arjun Reddy",
    qualification: "MBBS, MS - ENT, DNB - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "16 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Revision Rhinoplasty Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, MS - ENT, MCh - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "14 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Ethnic Rhinoplasty Expert"
  },
  {
    name: "Dr. Vikram Singh",
    qualification: "MBBS, MS - ENT, Fellowship - Rhinoplasty",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "17 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Functional Rhinoplasty Specialist"
  },
  {
    name: "Dr. Sneha Patel",
    qualification: "MBBS, MS - ENT, MCh - Plastic Surgery",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Natural Rhinoplasty Expert"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Rhinoplasty Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert surgical care for nose reshaping with natural results, improved breathing, and enhanced facial harmony.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const Rhinoplasty = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Advanced Rhinoplasty Surgery
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Complete Nose Reshaping with 96% Success Rate. Natural Results with Enhanced Breathing and Facial Harmony.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              Revision Rhinoplasty Care
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>96%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Patient Satisfaction Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>2-4</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Hours Procedure Time</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>6-12</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Months Final Results</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>18+</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Years Expert Surgeons</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "benefits", label: "Benefits", icon: "✨" },
              { id: "types", label: "Types", icon: "🎯" },
              { id: "procedure", label: "Procedure", icon: "🔬" },
              { id: "recovery", label: "Recovery", icon: "⚕️" },
              { id: "candidates", label: "Candidates", icon: "👥" },
              { id: "faq", label: "FAQ", icon: "❓" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Rhinoplasty Surgery</span>
            </h2>
          </div>

          {/* What is Rhinoplasty */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Rhinoplasty
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                Rhinoplasty, commonly known as a "nose job," is a sophisticated surgical procedure that reshapes 
                and reconstructs the nose to improve both its appearance and function. This delicate procedure 
                requires precise surgical skill to achieve natural-looking results that harmonize with your 
                facial features while maintaining or improving nasal breathing.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Aesthetic Goals</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Reshape nasal bridge, refine nasal tip, adjust nostril size, correct asymmetries, 
                      and create better facial balance while preserving ethnic characteristics.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Functional Benefits</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Correct deviated septum, improve nasal airflow, repair nasal valve collapse, 
                      and address breathing difficulties caused by structural nasal abnormalities.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Benefits & Advantages */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Benefits & Advantages of Rhinoplasty
            </h3>

            <div className="row">
              {[
                {
                  title: "Enhanced Facial Harmony", 
                  description: "Creates balanced facial proportions and improves overall facial aesthetics",
                  details: "Natural-looking results that complement your unique features"
                },
                {
                  title: "Improved Breathing", 
                  description: "Corrects structural issues that obstruct nasal airflow and cause breathing difficulties",
                  details: "Dual benefit of cosmetic enhancement and functional improvement"
                },
                {
                  title: "Boosted Confidence", 
                  description: "Significantly improves self-esteem and body image through enhanced appearance",
                  details: "Life-changing psychological benefits and increased social confidence"
                },
                {
                  title: "Permanent Results", 
                  description: "Provides long-lasting changes that maintain their appearance over time",
                  details: "Lifetime benefits with proper surgical technique"
                },
                {
                  title: "Customized Approach", 
                  description: "Tailored surgical plan designed specifically for your anatomical needs and goals",
                  details: "Personalized treatment accounting for ethnic background and facial structure"
                },
                {
                  title: "Minimal Scarring", 
                  description: "Strategic incision placement ensures scars are well-hidden and inconspicuous",
                  details: "Closed rhinoplasty leaves no visible external scars"
                }
              ].map((benefit, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {benefit.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {benefit.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {benefit.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Rhinoplasty Types & Classification */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Rhinoplasty Types & Classification
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Open Rhinoplasty",
                    description: "External incision across columella for maximum visibility, ideal for complex cases and major reshaping",
                    treatment: "Best for revision cases, major deformities, and complex tip work"
                  },
                  {
                    type: "Closed Rhinoplasty",
                    description: "All incisions inside nostrils leaving no visible scars, faster recovery with less swelling",
                    treatment: "Ideal for minor to moderate corrections and primary rhinoplasty"
                  },
                  {
                    type: "Ethnic Rhinoplasty",
                    description: "Specialized approach preserving ethnic characteristics while enhancing nasal features",
                    treatment: "Customized techniques for different ethnic nasal structures"
                  },
                  {
                    type: "Revision Rhinoplasty",
                    description: "Corrects unsatisfactory results from previous surgeries, more complex procedure",
                    treatment: "Requires expert surgeon with revision rhinoplasty experience"
                  },
                  {
                    type: "Functional Rhinoplasty",
                    description: "Focuses on improving breathing while maintaining or enhancing nasal appearance",
                    treatment: "Combines septoplasty with cosmetic improvements"
                  },
                  {
                    type: "Liquid Rhinoplasty",
                    description: "Non-surgical approach using fillers for minor contour improvements, temporary results",
                    treatment: "Suitable for small dorsal humps and minor asymmetries"
                  }
                ].map((type, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {type.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {type.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {type.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Candidates & Considerations */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Ideal Candidates & Considerations
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Good Candidates</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Physically healthy individuals</li>
                      <li style={{ marginBottom: "10px" }}>Non-smokers or willing to quit</li>
                      <li style={{ marginBottom: "10px" }}>Realistic expectations about results</li>
                      <li style={{ marginBottom: "10px" }}>Facial growth complete (typically 15+ for women, 17+ for men)</li>
                      <li>Specific nasal concerns affecting appearance or breathing</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Important Considerations</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Final results take 6-12 months to fully manifest</li>
                      <li style={{ marginBottom: "10px" }}>Temporary swelling and bruising expected</li>
                      <li style={{ marginBottom: "10px" }}>Nasal packing and splints may be used initially</li>
                      <li style={{ marginBottom: "10px" }}>Activity restrictions during recovery period</li>
                      <li>Possible need for revision in complex cases</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Treatment Approaches
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Non-Surgical Rhinoplasty
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    Injectable fillers provide temporary nasal contour improvements without surgery, 
                    ideal for minor corrections and patients not ready for surgical intervention.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Non-Surgical Options:</h6>
                    <div className="row">
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Dorsal hump camouflage</li>
                          <li style={{ marginBottom: "8px" }}>Nasal bridge augmentation</li>
                          <li style={{ marginBottom: "8px" }}>Tip refinement</li>
                        </ul>
                      </div>
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Asymmetry correction</li>
                          <li style={{ marginBottom: "8px" }}>Lift drooping nasal tip</li>
                          <li style={{ marginBottom: "8px" }}>Smooth nasal contours</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Limitations:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}>Temporary results (6-18 months)</li>
                      <li style={{ marginBottom: "8px" }}>Cannot reduce nasal size</li>
                      <li style={{ marginBottom: "8px" }}>Limited correction capabilities</li>
                      <li>Cannot improve breathing function</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Surgical Rhinoplasty Options
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Primary Rhinoplasty:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>First-time nasal surgery for cosmetic or functional improvement</li>
                      <li style={{ marginBottom: "10px" }}>Customized approach based on individual anatomy and goals</li>
                      <li style={{ marginBottom: "10px" }}>Performed under general anesthesia or IV sedation</li>
                      <li style={{ marginBottom: "10px" }}>2-4 hour procedure time depending on complexity</li>
                      <li>Highest success rates with proper patient selection</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Advanced Techniques:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Preservation rhinoplasty techniques</li>
                      <li style={{ marginBottom: "10px" }}>Structural rib cartilage grafting</li>
                      <li style={{ marginBottom: "10px" }}>Precision tip sculpting methods</li>
                      <li style={{ marginBottom: "10px" }}>Computer imaging for surgical planning</li>
                      <li>3D simulation for result preview</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Combined Procedures:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Rhinoplasty with septoplasty</li>
                      <li style={{ marginBottom: "10px" }}>Nasal valve repair included</li>
                      <li style={{ marginBottom: "10px" }}>Combination with chin augmentation</li>
                      <li>Simultaneous functional and cosmetic improvements</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Surgical Procedure Timeline */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Surgical Procedure & Recovery Timeline
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Week 1-2",
                    title: "Initial Recovery",
                    activities: ["Splint and packing removal", "Significant swelling and bruising", "Nasal breathing difficult", "Rest and limited activity"]
                  },
                  {
                    period: "Week 3-6",
                    title: "Early Healing",
                    activities: ["Major swelling subsides", "Bruising resolves completely", "Return to normal activities", "Nose appears wide and upturned"]
                  },
                  {
                    period: "Month 2-6",
                    title: "Intermediate Healing",
                    activities: ["Subtle swelling decreases", "Nasal tip refinement visible", "Final shape begins to emerge", "Most social activities resume"]
                  },
                  {
                    period: "Month 6-12",
                    title: "Final Results",
                    activities: ["Last 10% of swelling resolves", "Final nasal contour achieved", "Complete healing internally", "Optimal breathing function"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Prevention & Aftercare */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Post-operative Care & Instructions
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Immediate Post-op Care</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Keep head elevated at 45 degrees for first week</li>
                      <li style={{ marginBottom: "10px" }}>Apply cold compresses to reduce swelling</li>
                      <li style={{ marginBottom: "10px" }}>Avoid blowing nose for 2-3 weeks</li>
                      <li>Take prescribed medications as directed</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Long-term Care</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Avoid strenuous exercise for 4-6 weeks</li>
                      <li style={{ marginBottom: "10px" }}>Wear sunscreen on nose to protect healing skin</li>
                      <li style={{ marginBottom: "10px" }}>No glasses resting on nose bridge for 6 weeks</li>
                      <li>Attend all follow-up appointments</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "Is rhinoplasty painful?",
                  answer: "Rhinoplasty involves manageable discomfort rather than severe pain. During the procedure, patients are under anesthesia and feel no pain. In the first 48 hours after surgery, most patients experience congestion, pressure, and mild to moderate discomfort that is well-controlled with prescribed pain medication. The sensation is often described as similar to having a severe cold or sinus infection. By day 3-4, most patients transition to over-the-counter pain relievers. The splint removal at one week may cause minor discomfort, but the overall pain level is typically less than most people anticipate. Proper pain management and following post-operative instructions significantly minimize discomfort throughout recovery."
                },
                {
                  question: "How long do rhinoplasty results last?",
                  answer: "Rhinoplasty provides permanent results that last a lifetime. The structural changes made to the nasal bones and cartilage are permanent. However, it's important to understand that the nose continues to age naturally along with the rest of your face. Minor changes may occur over decades due to the natural aging process, but the fundamental reshaping achieved through surgery remains. The nasal tip may droop slightly with age, similar to how it would have without surgery, but the overall improved shape and proportions are maintained. Revision rates are typically 5-15% depending on the complexity of the initial procedure and the surgeon's experience. With proper surgical technique and good healing, most patients enjoy their rhinoplasty results permanently."
                },
                {
                  question: "When will I see my final rhinoplasty results?",
                  answer: "Rhinoplasty results evolve gradually over 12-18 months. Immediately after surgery, significant swelling makes the nose appear larger than the final result. The timeline is: First 2 weeks - Major swelling and bruising; 1-3 months - 60-70% of swelling resolves, basic shape visible; 6 months - 90% of swelling gone, refined shape emerging; 12 months - Final result nearly complete; 12-18 months - Last subtle swelling resolves, final contour achieved. The nasal tip is the last area to fully refine, often taking the longest to show final definition. Patience is crucial during this process, as premature judgment of results can be misleading. Your surgeon will monitor your healing progress and guide you through each stage of recovery."
                },
                {
                  question: "Can rhinoplasty improve breathing problems?",
                  answer: "Yes, rhinoplasty can significantly improve breathing when combined with functional corrections. This dual-purpose approach is often called functional rhinoplasty or septorhinoplasty. Common breathing issues addressed include: Deviated septum correction - straightening the nasal partition; Nasal valve repair - strengthening collapsed nasal valves; Turbinate reduction - addressing enlarged nasal turbinates; Nasal airway enlargement - increasing nasal passage dimensions. In fact, many patients choose rhinoplasty specifically to resolve long-standing breathing difficulties while simultaneously enhancing nasal appearance. The functional improvements are immediate once swelling subsides, with patients reporting dramatically improved airflow, reduced snoring, better sleep quality, and enhanced exercise tolerance. Comprehensive pre-operative assessment ensures both aesthetic and functional goals are achieved."
                },
                {
                  question: "What's the difference between open and closed rhinoplasty?",
                  answer: "Open and closed rhinoplasty are two surgical approaches with distinct advantages: Open rhinoplasty involves a small external incision across the columella (the tissue between nostrils), providing direct visualization of nasal structures. Benefits include better access for complex cases, precise grafting, and improved symmetry correction. Closed rhinoplasty uses only internal incisions within the nostrils, leaving no visible scars. Advantages include faster surgery time, less swelling, and quicker initial recovery. The choice depends on: Surgeon preference and training; Complexity of the case; Need for major structural work; Revision versus primary surgery; Patient anatomy and goals. Neither approach is inherently superior - the best technique depends on individual circumstances. Experienced surgeons choose the approach that will deliver optimal results for each specific case while minimizing trade-offs."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Ready for Rhinoplasty?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our expert surgeons provide natural-looking rhinoplasty results with enhanced breathing and facial harmony.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Consultation Now
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Plastic Surgery: <strong>080-6541-7705</strong> | ENT: <strong>080-6541-7715</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default Rhinoplasty;